import * as React from 'react'

import { Button } from 'reactstrap'

import TerminationFormData from '../TerminationFormData.interface'
import TerminationFormDataUpdate from '../TerminationFormDataUpdate.type'

import { formatName } from 'src/lib/helpers/format'

export interface TerminationInitialConfirmationProps {
  terminationForm: TerminationFormData,
  statusCallback: TerminationFormDataUpdate
}

class TerminationInitialConfirmation extends React.PureComponent<TerminationInitialConfirmationProps> {
  get employeeName() {
    const { terminationForm } = this.props
    return formatName(terminationForm.employee)
  }

  render() {
    const { terminationForm, statusCallback } = this.props  

    return (
      <div className="p4">
        <h5 className="text-justify mb-4">You have selected to terminate <b>{this.employeeName}</b>. Are you sure you want to proceed?</h5>

        <Button color="primary" className="btn-block" onClick={e => statusCallback('CHECK_VOLUNTARY', terminationForm)}>
          Proceed With Termination
        </Button>
        <Button color="light" className="btn-block" onClick={e => statusCallback(null, undefined)}>
          Cancel Termination
        </Button>
      </div>
    )
  }

}

export default TerminationInitialConfirmation


// WEBPACK FOOTER //
// ./src/routes/terminations/termination-flow/components/TerminationInitialConfirmation.component.tsx